(ns ycweb.app.website.cart.pages.payment.instore
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.forms :as forms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc choose-store < rum/reactive cmn/cursors [app-atom process-atom cart-atom]
  (let [collection-stores (cmn/curact app-atom [:delivery-list :collection_stores])

        ;; Pre-select store from delivery if available, otherwise use payment store
        selected-store-uuid
        (or
          (cmn/curact cart-atom [:cart :payment :store_uuid])
          (cmn/curact cart-atom [:cart :delivery :collection_store_uuid]))

        selected-store
        (->>
          collection-stores
          (filter #(= (:uuid %) selected-store-uuid))
          first)

        selected-province
        (or
          (cmn/curact cart-atom [:payment_details :province])
          (:province selected-store))

        selected-city
        (or
          (cmn/curact cart-atom [:payment_details :city])
          (:city selected-store))

        ;; Group collection points by province
        provinces
        (->> collection-stores
          (map :province)
          (filter identity)
          (set)
          (sort))

        ;; Filter cities by selected province
        cities-in-province
        (->> collection-stores
          (filter #(= (:province %) selected-province))
          (map :city)
          (set)
          (sort))

        visible-stores
        (filter #(and (= (:province %) selected-province)
                   (= (:city %) selected-city)) collection-stores)

        confirm-store
        (fn [e]
          (.preventDefault e)
          ;; Save the selected store to payment store_uuid
          (when selected-store-uuid
            (let [order-id (cmn/curact cart-atom [:order :id])
                  order-hash (cmn/curact cart-atom [:order :h])]
              (swap! cart-atom assoc-in [:cart :payment :store_uuid] selected-store-uuid)
              (model/update-order-payment-store app-atom
                {:order-id order-id
                 :store-uuid selected-store-uuid
                 :order-hash order-hash}
                (fn [response]
                  (when (:success response)
                    (cart.common/push-substep process-atom :qr-code)))))))]

    (cart.common/checkout-layout process-atom false
      (list
        [:h2.yc-heading.yc-heading--default {:key "store-heading"} "Choose your nearest Yuppiechef store"]
        [:p.yc-paragraph {:key "store-note"}
         [:b "Please note: "]
         "You won't be able to take your gift from the store. Your gift will be sent directly to the happy couple, along with all their other gifts, once they've closed their registry and instructed us to deliver it to them."]
        [:hr.u-hr {:key "store-hr"}]
        [:p.form-question {:key "store-prompt"} "Find your nearest Yuppiechef retail store:"]

        (when (seq provinces)
          [:div.u-max-width-320.u-margin-bottom-16 {:key "province-select"}
           (forms/select "Province"
             (rum/cursor-in cart-atom [:payment_details :province])
             (concat
               [{:text "Select a province" :value ""}]
               (map (fn [province] {:text province :value province}) provinces))
             {:change-fn
              (fn [e]
                ;; Clear city and store selection when province changes
                (swap! cart-atom assoc-in [:payment_details :city] nil)
                (swap! cart-atom assoc-in [:cart :payment :store_uuid] nil))})])

        (when cities-in-province
          [:div.u-max-width-320.u-margin-bottom-16 {:key "city-select"}
           (forms/select "City"
             (rum/cursor-in cart-atom [:payment_details :city])
             (concat
               [{:text "Select a city" :value ""}]
               (map (fn [city] {:text city :value city}) cities-in-province))
             {:change-fn
              (fn [e]
                ;; Clear store selection when city changes
                (swap! cart-atom assoc-in [:cart :payment :store_uuid] nil))})])

        [:div.u-max-width-320.u-margin-bottom-16 {:key "store-select"}
         (forms/select "Store"
           (rum/cursor-in cart-atom [:cart :payment :store_uuid])
           (concat
             [{:text (if (seq visible-stores) "Select a store" "Please select a city first") :value ""}]
             (map (fn [store] {:text (:name store) :value (:uuid store)}) visible-stores))
           {})]

        (when (:address selected-store)
          [:p.yc-paragraph {:key "store-address"}
           [:b (:name selected-store)]
           (when (:maps_link selected-store)
             [:<> " - " [:a {:href (:maps_link selected-store) :target "_blank" :class "text-link"} "View on Google Maps"]])
           [:br]
           (:address selected-store)
           (when (:address selected-store) [:br])
           (when (and (:suburb selected-store) (not= (:suburb selected-store) (:city selected-store)))
             [:<>
               (:suburb selected-store)
               [:br]])
           (:city selected-store)
           (when (:city selected-store) [:br])
           (:province selected-store)
           (when (:province selected-store) [:br])
           (:postcode selected-store)]))

      (cart.common/checkout-cta-sidebar-simple
        (buttons/button-web "Confirm Store Selection"
          {:on-click confirm-store
           :disabled (nil? selected-store-uuid)
           :style :primary
           :class "checkout-cta__button"})
        nil
        (cmn/curact cart-atom [:order :number])
        cart-atom
        {:total-key :balance}))))

(rum/defc qr-code-page < rum/reactive cmn/cursors [app-atom process-atom cart-atom]
  (let [order-number (cmn/curact cart-atom [:order :number])
        amount-owing (get-in (rum/react cart-atom) [:totals :balance])

        ;; Get selected store details
        collection-stores (cmn/curact app-atom [:delivery-list :collection_stores])
        selected-store-uuid (cmn/curact cart-atom [:cart :payment :store_uuid])
        selected-store
        (->>
          collection-stores
          (filter #(= (:uuid %) selected-store-uuid))
          first)

        qr-code-url (str "/api/qr/order/" order-number ".png")]

    (cart.common/checkout-layout process-atom false
      (list
        (rum/with-key
          (feedback/feedback :success
            (str "We've received your order " order-number)
            (str "Amount owing: R" (u/currency-format amount-owing)))
          "instore-feedback")

        [:div.u-max-width-200.u-margin-bottom-24 {:key "qr-code"}
         [:img.yc-simple-image.yc-simple-image--full
          {:src qr-code-url
           :alt "Order QR Code"}]]

        [:h2.yc-heading.yc-heading--default {:key "next-heading"} "What happens next?"]
        [:p.yc-paragraph {:key "next-desc"}
         "We've sent you confirmation by email. Show the special QR code in the email to any sales assistant, and they'll help you finish your payment."]

        (when selected-store
          [:div.u-margin-top-24 {:key "selected-store"}
           [:h3.yc-heading.yc-heading--tiny "Your selected store"]
           [:p.yc-paragraph
            [:b (:name selected-store)]
            (when (:maps_link selected-store)
              [:<> " - " [:a {:href (:maps_link selected-store) :target "_blank" :class "text-link"} "View on Google Maps"]])
            [:br]
            (:address selected-store)
            (when (:address selected-store) [:br])
            (when (and (:suburb selected-store) (not= (:suburb selected-store) (:city selected-store)))
              [:<>
                (:suburb selected-store)
                [:br]])
            (:city selected-store)
            (when (:city selected-store) [:br])
            (:province selected-store)
            (when (:province selected-store) [:br])
            (:postcode selected-store)]])

        [:p.yc-paragraph {:key "qr-note"}
         [:b "Please note: "]
         "You won't be able to take your gift from the store. Your gift will be sent directly to the happy couple, along with all their other gifts, once they've closed their registry and instructed us to deliver it to them."])

      (cart.common/checkout-cta-sidebar-simple
        (buttons/button-web "Done"
          {:on-click
           (fn [e]
             (.preventDefault e)
             (urlstate/redirect! "/"))
           :style :cta
           :class "checkout-cta__button"})
        nil
        order-number
        cart-atom
        {:total-key :balance}))))

(rum/defc instore-page < rum/reactive cmn/cursors [app-atom process-atom cart-atom]

  (let [instore-substep (cart.common/current-substep process-atom)]
    (case instore-substep
      :qr-code (qr-code-page app-atom process-atom cart-atom)
      (choose-store app-atom process-atom cart-atom))))
